import { Box, Container, Grid } from "@mui/material";
import React from "react";
import Img1 from "./../assets/images/nordstrom/nordstrome_first.jpg";
import Img2 from "./../assets/images/nordstrom/nordstrome_second.jpg";
import Img3 from "./../assets/images/nordstrom/nordstrome_third.jpg";
import Img4 from "./../assets/images/nordstrom/nordstrome_four.jpg";
import Img5 from "./../assets/images/nordstrom/nordstrome_five.jpg";
import Img6 from "./../assets/images/nordstrom/nordstrome_six.jpg";
import Img7 from "./../assets/images/nordstrom/nordstrome_seven.jpg";
import Img8 from "./../assets/images/nordstrom/nordstrome_eight.jpg";
import Img9 from "./../assets/images/nordstrom/nordstrome_nine.jpg";

import Project_first from "./../assets/images/relatedprojects/ashley_furniture.jpg";
import Project_second from "./../assets/images/relatedprojects/sage_hill.png";
import Project_third from "./../assets/images/relatedprojects/simons.jpg";
import Project_four from "./../assets/images/relatedprojects/gulf_canada.jpg";

import Contentimages from "../components/Contentimages";
import PostRealetedDates from "../components/PostRealetdDates";
import ProtfolioNavigation from "../components/ProtfolioNavigation";
import RelatedProjects from "../components/RelatedProjects";
import { useDocumentMetaData } from "../components/useDocumentMetaData";

const Nordstrom = () => {
  const imageArray = [Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8, Img9];

  const relatedDates = [
    {
      title: "Burnet, Duckworth & Palmer LLP",
      url: "/portfolio_page/burnet-duckworth-palmer/",
      date: "September 24, 2012",
    },
    {
      title: "National Music Centre",
      url: "/portfolio_page/national-music-centre/",
      date: "January 21, 2017",
    },
    {
      title: "Devon 3 Fitness Centre",
      url: "/portfolio_page/devon-3-fitness-centre/",
      date: "February 26, 2019",
    },
  ];

  const projects = [
    {
      title: "Ashley Furniture HomeStore",
      firm: "Retail",
      image: Project_first,
      link: "/portfolio_page/ashley-furniture-homestore/",
    },
    {
      title: "Sage Hill Quarter",
      firm: "Retail",
      image: Project_second,
      link: "/portfolio_page/sage-hill-quarter/",
    },
    {
      title: "Simons",
      firm: "Retail",
      image: Project_third,
      link: "/portfolio_page/simons/",
    },
    {
      title: "Gulf Canada Square Food Court",
      firm: "Retail",
      image: Project_four,
      link: "/portfolio_page/gulf-canada-square/",
    },
  ];

  const onUrlClick = (url) => {
    window.open(url, "_blank");
  };

  useDocumentMetaData({
    title: "Nordstrom - MidWest Group",
    description:
      "MidWest Group completed ceilings, wall steel stud, unistrut packages, and cloud ceiling installations for Nordstrom at Chinook Centre in Calgary, Alberta, delivering high-quality finishes.",
    keywords:
      "Nordstrom, Calgary, MidWest Group, ceilings, drywall, unistrut, cloud ceilings, Chinook Centre, Aluminum Fry Reglet, Formglas Columns, 9Wood Ceilings",
    canonical: "https://www.midwest-group.com/portfolio_page/nordstrom/",
    author: "MidWest Group",
    ogTitle: "Nordstrom Chinook Centre Project",
    ogDescription:
      "MidWest Group provided finished ceilings, wall steel stud, unistrut packages, and cloud ceilings for Nordstrom in Calgary’s Chinook Centre.",
    ogImage: "https://www.midwest-group.com/static/media/nordstrome_first.48d22b0e176c478838fc.jpg",
    ogUrl: "https://www.midwest-group.com/portfolio_page/nordstrom/",
    twitterTitle: "Nordstrom Chinook Centre Project",
    twitterDescription:
      "MidWest Group delivered ceilings, wall steel stud, unistrut, and cloud ceiling installations for Nordstrom at Chinook Centre, Calgary.",
    twitterImage:
      "https://www.midwest-group.com/static/media/nordstrome_first.48d22b0e176c478838fc.jpg",
  });

  return (
    <>
      <div className="parent-div">
        <Container
          fixed
          className="parent-container"
          style={{ paddingLeft: "0px", paddingRight: "0px" }}
        >
          <Box>
            <Contentimages
              tab={"Calgary, Alberta"}
              heading={"Nordstrom"}
              imageArray={imageArray}
            >
              MidWest Contracting is pleased to be part of the completion of
              Nordstrom in Chinook Centre. Our team provided finished ceilings,
              wall steel stud and a unistrut package to the 137.259 square feet
              space. A few of our accomplishments include installing an
              <span
                className="portfolio_url_text"
                onClick={() => {
                  onUrlClick("http://fryreglet.com/");
                }}
              >
                {" "}
                Aluminum Fry Reglet{" "}
              </span>
              lighting reveal,
              <span
                className="portfolio_url_text"
                onClick={() => {
                  onUrlClick("https://www.formglas.com/");
                }}
              >
                {" "}
                Formglas Columns{" "}
              </span>
              (glass fiber reinforced gypsum) and cloud ceilings with a level 5
              finish. These cloud ceilings were hung with pencil rod and we
              supplied 1-5/8” Metal unistrut for display units; which was
              standard throughout the entire store. One of the most noticeable
              pieces of the project is the
              <span
                className="portfolio_url_text"
                onClick={() => {
                  onUrlClick("https://www.9wood.com/");
                }}
              >
                {" "}
                9Wood Ceilings{" "}
              </span>
              that we installed with a T-bar grid suspension above and with
              eucalyptus plain sliced veneer.
            </Contentimages>

            <Grid container paddingBottom={10}></Grid>
            <PostRealetedDates relatedDates={relatedDates} />
            <ProtfolioNavigation
              backUrl="/portfolio_page/gulf-canada-square/"
              nextUrl="/portfolio_page/imperial-oil-quarry-park/"
            />
            <RelatedProjects projects={projects} />
          </Box>
        </Container>
      </div>
    </>
  );
};

export default Nordstrom;
